/** Página local — entra direto na sala (o demo Cloudflare ignora showSetupScreen=false). */
const REALTIMEKIT_MEETING_PATH = '/papo-realtimekit-meeting.html';

export const buildDyteURL = dyteAuthToken => {
  const params = new URLSearchParams({
    authToken: dyteAuthToken,
  });

  return `${REALTIMEKIT_MEETING_PATH}?${params.toString()}`;
};
